import React from 'react';
import * as styles from './styles.module.scss';

export function PlayButton() {
    return (
        <svg
            width="130"
            height="130"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.playButton}
        >
            <path d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z" />
        </svg>
    );
}
